export default __webpack_public_path__ + "static/media/headshott.efcd4175.jpg";